{
    "componentDetails": null,
    "showZeroQuantityParts": true,
    "componentMaterialPaging": {
        "offset": 50,
        "page": 1
    },
    "componentMaterialTotalCount": 0,
    "componentMaterialSortExpression": null,
    "componentMaterialFilterExpression": null,
    "componentMaterial": null,
    "componentSpecificationPaging": {
        "offset": 5000,
        "page": 1
    }
}